/**
 * @generated SignedSource<<87e0ca668c4ceca3ae4696a884d19add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_user">;
  readonly " $fragmentType": "PdpSharedDetailShipping_user";
};
export type PdpSharedDetailShipping_user$key = {
  readonly " $data"?: PdpSharedDetailShipping_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "afccbbe303fd03b9369ba8b0078b0ddb";

export default node;
